<template>
  <Toast type="info-neutral" icon="iconoir-info-empty">
    <template #title>{{ $t('userSessionExpiredToast.title') }}</template>
    <span> {{ $t('userSessionExpiredToast.content') }}</span>
  </Toast>
</template>

<script>
import Toast from '@baserow/modules/core/components/toasts/Toast'
import { TOAST_AUTO_DISMISS_MS } from '@baserow/modules/core/utils/toastConstants'

export default {
  name: 'UserSessionExpiredToast',
  components: {
    Toast,
  },
  mounted() {
    // Was a bare 7000ms literal, 2s longer than every other toast for no
    // stated reason. Shares the dismiss window now, and the handle is kept so
    // the timer cannot fire after the component is gone.
    this.acknowledgeTimeout = setTimeout(() => {
      this.acknowledgeTimeout = null
      this.acknowledge()
    }, TOAST_AUTO_DISMISS_MS)
  },
  beforeUnmount() {
    if (this.acknowledgeTimeout) {
      clearTimeout(this.acknowledgeTimeout)
      this.acknowledgeTimeout = null
    }
    this.acknowledge()
  },
  methods: {
    acknowledge() {
      this.$store.dispatch('toast/setUserSessionExpired', false)
    },
  },
}
</script>
